import { render, staticRenderFns } from "./art_special_project.vue?vue&type=template&id=9b72aa4a&scoped=true&"
import script from "./art_special_project.vue?vue&type=script&lang=js&"
export * from "./art_special_project.vue?vue&type=script&lang=js&"
import style0 from "./art_special_project.vue?vue&type=style&index=0&id=9b72aa4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b72aa4a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseTheCookie: require('/web/components/base/TheCookie.vue').default,BaseTheNewFooter: require('/web/components/base/TheNewFooter.vue').default})
